import Card from './Card';
import GameInfo from './GameInfo';
import GameMat from './GameMat';
import HandCards from './HandCards';
import PlayerInfo from './PlayerInfo';
import PlayerProfile from './PlayerProfile';
import Resolution from './Resolution';

export {
  Card,
  GameInfo,
  GameMat,
  HandCards,
  PlayerInfo,
  PlayerProfile,
  Resolution,
}



// WEBPACK FOOTER //
// ./src/components/Game/components/index.js